import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const CustomerPreviewContext = createContext(null);

export function CustomerPreviewProvider({ children }) {
  const [previewId, setPreviewId] = useState(null);

  const openCustomerPreview = useCallback((customerId) => {
    if (!customerId) return;
    setPreviewId(customerId);
  }, []);

  const closeCustomerPreview = useCallback(() => {
    setPreviewId(null);
  }, []);

  const value = useMemo(
    () => ({ previewId, openCustomerPreview, closeCustomerPreview }),
    [previewId, openCustomerPreview, closeCustomerPreview]
  );

  return (
    <CustomerPreviewContext.Provider value={value}>
      {children}
    </CustomerPreviewContext.Provider>
  );
}

export function useCustomerPreview() {
  const ctx = useContext(CustomerPreviewContext);
  if (!ctx) {
    return {
      previewId: null,
      openCustomerPreview: () => {},
      closeCustomerPreview: () => {},
    };
  }
  return ctx;
}
